import { ButtonProps } from '@mui/material/Button'

export const getPaddingForSize = ({ size }: Pick<ButtonProps, 'size'>) => {
  switch (size) {
    case 'large':
      return '12px 24px'
    case 'small':
      return '8px 16px'
    case 'medium':
    default:
      return '8px 24px'
  }
}
export const getFontSize = ({ size }: Pick<ButtonProps, 'size'>) => {
  switch (size) {
    case 'small':
      return '14px'
    case 'large':
    case 'medium':
    default:
      return '16px'
  }
}
